// extracted by mini-css-extract-plugin
export default {"large":"only screen and (min-width: 992px)","overlayContainer":"eYzcJ","inline":"VmZdQ","title":"q7J56","description":"dgOwH","modal":"v4VFe"};